export default __webpack_public_path__ + "5a25b64fc56aa314f3c81efe02b86383.gif";